"use client";

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "./toast";
import { dismissToast, useToasts } from "@/hooks/use-toast";

export function Toaster() {
  const items = useToasts();
  return (
    <ToastProvider swipeDirection="right">
      {items.map((t) => (
        <Toast
          key={t.id}
          open={t.open}
          onOpenChange={(open) => {
            if (!open) dismissToast(t.id);
          }}
          variant={t.variant}
          duration={t.duration === 0 ? Infinity : t.duration ?? 4000}
        >
          <div className="grid gap-0.5 min-w-0">
            {t.title ? <ToastTitle>{t.title}</ToastTitle> : null}
            {t.description ? <ToastDescription>{t.description}</ToastDescription> : null}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
